import { createStyles } from 'antd-style';

import { mask } from '../../styles/mixins';

export const useModalOverlayStyles = createStyles((_, opacity) => ({
  mask: mask(opacity),
}));
